export default __webpack_public_path__ + "static/media/Pharaoh_1.3aaf9c34.gif";